import PropTypes from 'prop-types';
import React, { Component } from 'react';
import PostcodeAutocomplete from 'hui/dist/js/components/autocomplete/postcode-autocomplete';

import api from 'axios';
import memoize from 'lodash/memoize';

const $ = window.jQuery;
const RWD = require('../../../hui_core/scripts/components/responsive');

const rwd = new RWD({
  app: window.document
});
const fetchSuggestions = memoize(query =>
    api.get('/bunnings/locations', { params: { query } }));

export default class PostcodeSearch extends Component {
  static propTypes = { // eslint-disable-line
    classPrefix: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    valueStacked: PropTypes.string,
    placeholder: PropTypes.string,
    GACategory: PropTypes.string,
    GAAction: PropTypes.string,
    GALabel: PropTypes.string
  };

  static defaultProps = { // eslint-disable-line 
    classPrefix: 'gq-postcode',
    name: 'w',
    value: '',
    valueStacked: '',
    placeholder: 'Type suburb and pick from list e.g. 2000 - Sydney',
    GACategory: '',
    GAAction: '',
    GALabel: ''
  };

  state = {
    postcodeValue: '',
    viewportWidth: ''
  };

  UNSAFE_componentWillMount() {
    this.getPostcodeValue(rwd);
  }

  componentDidMount() {
    $(window).on('browserResized', () => {
      this.getPostcodeValue(rwd);
    });
  }

  componentWillUnmount() {
    $(window).on('browserResized', () => {
      this.getPostcodeValue(rwd);
    });
  }

  onChange = (postcodeValue) => {
    this.setState({ postcodeValue });
  };

  onSuggestionSelected = (event, { suggestion }) => {
    const postcodeValue = `${suggestion.postcode} - ${suggestion.suburb}`;
    this.setState({ postcodeValue });
    if (this.props.GACategory && this.props.GAAction && this.props.GALabel) {
      this.onTrackEvent(this.props.GACategory, this.props.GAAction, this.props.GALabel);
    }
    // this.formSubmit(event, postcodeValue);
  };

  onTrackEvent = (gaCategory, gaAction, gaLabel) => {
    if (this.props.GACategory && this.props.GAAction && this.props.GALabel) {
      window.pageTracker._trackEvent(gaCategory, gaAction, gaLabel); // eslint-disable-line no-underscore-dangle
    }
  };

  getPostcodeValue = (rwd) => {
    let postcodeValue;
    if (rwd.position.w < 1200 && this.props.valueStacked) {
      postcodeValue = this.props.valueStacked;
    } else {
      postcodeValue = this.props.value;
    }
    this.setState({ postcodeValue });
  };

  render() {
    const { postcodeValue } = this.state;
    return (
      <PostcodeAutocomplete
        classPrefix={this.props.classPrefix}
        value={postcodeValue}
        data-placeholder={this.props.placeholder}
        placeholder={this.props.placeholder}
        onChange={this.onChange}
        onSuggestionSelected={this.onSuggestionSelected}
        autoFocus
        name={this.props.name}
        fetchSuggestions={fetchSuggestions}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./module_get_quotes/scripts/components/postcode-autocomplete.js